/* eslint-disable react/jsx-pascal-case */
import { Component } from "react";
import styled from "styled-components";
import { NanoFlex } from "./NanoFlex.js";
import loadingMain from "../../images/Global/loadingMain.gif"

const StyledLoading = styled(NanoFlex)`
    display: flex;
    flex-wrap: wrap;
    background-color: white;    
    height: 25vh;
    margin-top: 40px;
    flex-direction: row;
    align-content: space-around;
    justify-content: space-around;
`;

class Loading extends Component {
   render() {
    return (
      <StyledLoading className="loadingContainer">
        <img src={loadingMain} alt="loading..." height="60" />
      </StyledLoading>
    );
  }
}

export default Loading;
